"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgExport(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "4 -4 16 24" }, props),
        React.createElement("path", { fill: "currentColor", d: "M8.873 0a2 2 0 00-1.408.58L4.59 3.437A2 2 0 004 4.855V15a1 1 0 001 1h11a1 1 0 001-1v-3h-2v2H6V6h3a1 1 0 001-1V2h5v2h2V1a1 1 0 00-1-1zM16 5v2h-3v2h3v2l4-3z" })));
}
exports.default = tombacIcon_1.default('Export')(SvgExport);
//# sourceMappingURL=Export.js.map